import { PaginatedParams, PaginatedResult } from "services/@types";
import apiInputService from "services/apiInputService";
import { Sow } from "./@types";
import { QueryClient, useQuery } from "@tanstack/react-query";
import { useSubscription } from "store/auth/auth-store";

const fetchGetSOWsOperative = async (
  params: PaginatedParams
): Promise<PaginatedResult<Sow>> => {
  const sows = await apiInputService.get(`/frontend/sow/operative`, {
    params: { ...params },
  });
  const { data } = sows;

  return data as PaginatedResult<Sow>;
};

export const useGetSOWsOperative = (
  params?: PaginatedParams,
  options?: {
    staleTime: number;
    onSuccess: (data: PaginatedResult<Sow>) => void;
  }
) => {
  const { subscription } = useSubscription();

  return useQuery(
    ["sowAdmById", subscription?.subscriptionId, params],
    () => fetchGetSOWsOperative(params),
    {
      ...options,
      keepPreviousData: true,
    }
  );
};

export const prefetchData = (
  queryClient: QueryClient,
  params: any,
  subscription: string
) => {
  queryClient.prefetchQuery(
    ["dashboard", "atvs", "department", subscription, params],
    () => fetch(params),
    {
      staleTime: 1000 * 60 * 5,
    }
  );
};
